import { render, staticRenderFns } from "./TransactionApproved.vue?vue&type=template&id=4f3dda37"
import script from "./TransactionApproved.vue?vue&type=script&lang=js"
export * from "./TransactionApproved.vue?vue&type=script&lang=js"
import style0 from "./TransactionApproved.vue?vue&type=style&index=0&id=4f3dda37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports